import i18n from "../i18n"

const preventKeysPhoneNumberFormat = [
    "ArrowLeft",
    "ArrowRight"
]

export async function phoneNumberFormatter(event, phoneNumber, phonenumberErrors) {
    if (
        event &&
        preventKeysPhoneNumberFormat.indexOf(event.key) !== -1
    ) {
        return { phoneNumber, phonenumberErrors };
    }

    let tempPhoneNumber = phoneNumber;
    if (tempPhoneNumber && tempPhoneNumber.length) {
        const lengthOfValidPhoneNumber = 11;
        const validHungarianMobileAreaCodes = ["20", "30", "31", "50", "70"];

        if (["06", "36"].includes(tempPhoneNumber.substring(0, 2))) {
            tempPhoneNumber = tempPhoneNumber.replace(
                tempPhoneNumber.substring(0, 2),
                "+36"
            );
        } else if (
            validHungarianMobileAreaCodes.includes(
                tempPhoneNumber.substring(0, 2)
            )
        ) {
            tempPhoneNumber = "+36" + tempPhoneNumber;
        }

        // removes every charachter, except numbers and first '+'
        tempPhoneNumber = tempPhoneNumber.trim();
        tempPhoneNumber = tempPhoneNumber.replace(/((?!^)\+|[^\d+])/g, "");

        phoneNumber = tempPhoneNumber;

        if (
            phoneNumber.length ==
            lengthOfValidPhoneNumber + 1
        ) {
            phonenumberErrors = [];
        }
        else {
            phonenumberErrors = [];
            phonenumberErrors.push(
                `${i18n.t('The mobile number format is not correct')}`
            );
        }

        return { phoneNumber, phonenumberErrors };
    }
}

export const phoneRule = function (value) {
    if (!value) {
        return true;
    }

    const hunMobilephonePattern = /^(\+36)(20|30|31|50|70)\d{7}$/;
    if (!hunMobilephonePattern.test(value)) {
        return `${i18n.t('The mobile number format is not correct')}`;
    } else {
        return true;
    }
}
